import React from 'react';
import logo from '../assets/images/yellow.png';
import { Link } from 'react-router-dom';

const ClassCard = (props) => {
  const {ebookUrl, url, bookname, classNameForPdf, image } = props;
  // console.log(url, bookname, classNameForPdf , fileId)
// console.log(fileId)
// console.log(props)
const importImage = (imageName) => {
  try {
    return require(`../assets/images/${imageName}`);
  } catch (e) {
    console.error('Error importing image:', e);
    return null;
  }
};

const imageSrc = importImage(image);


  const encodedClassName = encodeURIComponent(classNameForPdf);
  const encodedSubjectName = encodeURIComponent(bookname);
 return (
  <div className="group flex justify-center">

    <div
      className="
      relative
      w-[280px]
      rounded-[35px]
      bg-gradient-to-b
      from-[#fffdf7]
      via-[#ffffff]
      to-[#fff5eb]
      p-5
      shadow-lg
      border-4
      border-orange-100
      overflow-hidden
      transition-all
      duration-500
      hover:-translate-y-3
      hover:shadow-2xl
      hover:shadow-orange-200
      "
    >

      {/* Floating circles */}

      <div className="absolute top-4 right-4 w-4 h-4 rounded-full bg-pink-300 animate-pulse"></div>

      <div className="absolute bottom-8 left-4 w-5 h-5 rounded-full bg-blue-300 animate-bounce"></div>

      {/* Book badge */}

      <div className="absolute top-4 left-4">

        <div className="bg-yellow-300 text-xs font-bold px-3 py-1 rounded-full">

          📚 BOOK

        </div>

      </div>

      {/* Image */}

      <div className="mt-8 overflow-hidden rounded-3xl">

        {imageSrc ? (

          <img
            src={imageSrc}
            alt={bookname}
            className="
            h-56
            w-full
            object-cover
            transition-all
            duration-500
            group-hover:scale-110
            "
          />

        ) : (

          <img
            src={logo}
            alt="logo"
            className="h-56 w-full object-contain"
          />

        )}

      </div>

      {/* Title */}

      <h2
        className="
        mt-5
        text-center
        text-lg
        font-bold
        text-[#333]
        h-14
        flex
        items-center
        justify-center
        px-2
        "
      >

        {bookname}

      </h2>

      {/* Video Button */}

      <Link
        to={`/videos/${url}`}
        className="
        w-full
        flex
        justify-center
        items-center
        py-3
        mt-4
        rounded-full
        font-bold
        text-white
        bg-gradient-to-r
        from-[#4D96FF]
        to-[#6BCB77]
        hover:scale-105
        transition-all
        duration-300
        "
      >

        🎥 View Chapters

      </Link>

      {/* Ebook Button */}

      <a
        href={ebookUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="
        w-full
        flex
        justify-center
        items-center
        py-3
        mt-3
        rounded-full
        font-bold
        text-white
        bg-gradient-to-r
        from-[#FF8E53]
        to-[#FF6B6B]
        hover:scale-105
        transition-all
        duration-300
        "
      >

        📖 Read E-Book

      </a>

    </div>

  </div>
);
}

export default ClassCard;







